var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoocommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7f54b3",
    d: "M116.3 89.1H11.7C5.2 89.1 0 83.9 0 77.4v-40C0 31 5.2 25.8 11.7 25.8h104.7c6.4 0 11.7 5.2 11.7 11.7v40c-.1 6.4-5.3 11.6-11.8 11.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.8 76.7s2.8 11.8 8.5 3.9s11.2-20.3 11.2-20.3s.4-3.1 2 3.7S44 80 44 80s6.3 7.9 8.9-.4c-1-11 2.8-31 6.7-40.6c1.6-8.5-7.3-6.1-8.1-4.1s-6.3 14.8-6.7 28.2c0 0-4.7-12.8-5.1-17.4c-.4-4.7-5.3-5.9-8.1-1.4S20.3 66.2 20.3 66.2l-5.5-28.4s-5.5-7.3-8.7 1.6c0 0 5.7 34.9 7.7 37.3m73.2-31c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.7-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.3 2.3 4.1 7.4 3.8 11.4m38.4-12.5c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.6-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.2 2.3 4 7.4 3.8 11.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f54b3",
    d: "m61.3 89.1l22.3 13.1l-4.7-13.1l-12.8-3.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoocommerce);
export default __webpack_public_path__ + "static/media/woocommerce.b1f4836d2cde6143aa2e3eab28142b18.svg";
export { ForwardRef as ReactComponent };